import { render, staticRenderFns } from "./packageFo.vue?vue&type=template&id=f1061d58&scoped=true"
import script from "./packageFo.vue?vue&type=script&lang=js"
export * from "./packageFo.vue?vue&type=script&lang=js"
import style0 from "./packageFo.vue?vue&type=style&index=0&id=f1061d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1061d58",
  null
  
)

export default component.exports